var questions = [
	{
		list: [{
			question: "What's your favourite season?",
			options: [
				{
					option: "Fall",
					image: "Fall Shield BKG Icon-01-01",
					binding: 1
				},
				{
					option: "Spring",
					image: "Spring Shield BKG Icon-01-01-01-01",
					binding: 0
				},
				{
					option: "Summer",
					image: "Summer Shield BKG Icon-01-01-01-01",
					binding: 0
				},
				{
					option: "Winter",
					image: "Winter Shield BKG Icon-01-01",
					binding: 1
				}
			]
		}],
		folder: "season",
		drawOrder: 2
	},
	{
		list: [
			{
				question: "What's your favourite spring or summer sport?",
				options: [
					{
						option: "Beach Volleyball",
						image: "Volleyball Outdoor Character-01-01"
					},
					{
						option: "Football",
						image: "Football Character-01-01"
					},
					{
						option: "Lacrosse",
						image: "Lacrosse Character-01-01"
					},
					{
						option: "Rugby",
						image: "Rugby Character-01-01"
					},
					{
						option: "Soccer",
						image: "Soccer Character-01-01"
					},
					{
						option: "Swimming",
						image: "Swimming Character-01-01"
					}
				],
				featured: "Soccer Character-01-01"
			},
			{
				question: "What's your favourite winter or fall sport?",
				options: [
					{
						option: "Basketball",
						image: "Basketball Character-01-01"
					},
					{
						option: "Curling",
						image: "Curling Character-01-01-01"
					},
					{
						option: "Hockey",
						image: "Hockey Character-01-01"
					},
					{
						option: "Lacrosse",
						image: "Lacrosse Character-01-01"
					},
					{
						option: "Skating",
						image: "Skating Character-01-01-01-01"
					},
					{
						option: "Volleyball",
						image: "Volleyball Indoor Character-01-01"
					}
				],
				featured: "Curling Character-01-01-01"
			}
		],
		folder: "sport",
		drawOrder: 0
	},
	{
		list: [{
			question: "Which is the most majestic Canadian animal?",
			options: [
				{
					option: "Beaver",
					image: "Beaver-01"
				},
				{
					option: "Caribou",
					image: "Caribou-01"
				},
				{
					option: "Goose",
					image: "Geese-01"
				},
				{
					option: "Polar Bear",
					image: "Polar Bear-01"
				}
			],
			featured: "Beaver-01"
		}],
		folder: "animal",
		drawOrder: 1
	},
 	{
		list: [{
			question: "What's your favourite Canadian food?",
			options: [
				{
					option: "Bacon",
					image: "Bacon-01"
				},
				{
					option: "Doughnuts",
					image: "Doughnut-01"
				},
				{
					option: "Ketchup Chips",
					image: "Ketchup-01"
				},
				{
					option: "Maple Syrup",
					image: "Maple Syrup-01"
				},
				{
					option: "Poutine",
					image: "Poutine-01-01"
				}
			],
			featured: "Ketchup-01"
		}],
		folder: "food",
		drawOrder: 4
	},
	{
		list: [{
			question: "What's your drink of choice?",
			options: [
				{
					option: "Apple Cider",
					image: "Apple Cider-01"
				},
				{
					option: "Beer",
					image: "Beer-01"
				},
				{
					option: "Caesar",
					image: "Cesar-01"
				},
				{
					option: "Coffee",
					image: "Coffee-01"
				},
				{
					option: "Milk",
					image: "Milk-01"
				}
			],
			featured: "Cesar-01"
		}],
		folder: "drink",
		drawOrder: 5
	},
	{
		list: [{
			question: "In your spare time, what do you enjoy most?",
			options: [
				{
					option: "Art",
					image: "Art-01"
				},
				{
					option: "Movies",
					image: "Movies-01"
				},
				{
					option: "Music",
					image: "Music-01"
				},
				{
					option: "Sports",
					image: "Sports-01"
				}
			],
			featured: "Music-01"
		}],
		folder: "hobby",
		drawOrder: 6
	},
	{
		list: [{
			question: "What province or territory do you identify with most?",
			options: [
				{
					option: "Alberta",
					image: "Alberta-01-01"
				},
				{
					option: "British Columbia",
					image: "British Columbia-01-01"
				},
				{
					option: "Manitoba",
					image: "Manitoba-01-01"
				},
				{
					option: "New Brunswick",
					image: "New brunswick-01-01"
				},
				{
					option: "Newfoundland and Labrador",
					image: "Newfoundland-01-01"
				},
				{
					option: "Northwest Territories",
					image: "North West Terrorities-01-01"
				},
				{
					option: "Nova Scotia",
					image: "Nova Scotia-01-01"
				},
				{
					option: "Nunavut",
					image: "Nunavut-01-01"
				},
				{
					option: "Ontario",
					image: "Ontario-01-01"
				},
				{
					option: "Prince Edward Island",
					image: "PEI-01-01"
				},
				{
					option: "Quebec",
					image: "Quebec-01-01"
				},
				{
					option: "Saskatchewan",
					image: "Saskatchewan-01-01"
				},
				{
					option: "Yukon",
					image: "Yukon terrorities-01-01"
				}
			]
		}],
		folder: "province",
		drawOrder: 7
	},
	{
		list: [{
			question: "Choose a favourite Canadian landmark",
			options: [
				{
					option: "CN Tower",
					image: "CN Tower-01-01"
				},
				{
					option: "Niagara Falls",
					image: "Niagara Falls-01-01"
				},
				{
					option: "Parliament Hill",
					image: "Parliament Hill-01-01"
				},
				{
					option: "Rocky Mountains",
					image: "Rocky Mountains-01-01"
				},
				{
					option: "Vegreville Ukrainian Easter Egg",
					image: "Vegreville Ukrainian Easter Egg-01-01"
				}
			],
			featured: "Rocky Mountains-01"
		}],
		folder: "landmark",
		drawOrder: 8
	},
	{
		list: [{
			question: "Finally, pick a motto",
			options: [
				{
					option: "Oh Canada, Our Home And Native Land",
					image: "Oh Canada, Our Home and Native Land-01-01-01-01"
				},
				{
					option: "From Sea to Sea",
					image: "Sea to Sea-01-01-01-01"
				},
				{
					option: "Strength in Diversity",
					image: "Strength in Diversity-01-01-01-01"
				},
				{
					option: "Sorry",
					image: "Sorry-01-01-01-01"
				},
				{
					option: "Canada is eh-OK",
					image: "Canada is Eh Ok-01-01-01"
				}
			]
		}],
		folder: "motto",
		drawOrder: 10
	}
]

export default questions


//////////////////
// WEBPACK FOOTER
// ./static/questions.js
// module id = 90
// module chunks = 1